<template>
    <div v-hotkey="keymap" class="run-button">
        <div v-if="nakdanRunning" class="spinner">
            <spinner></spinner>
        </div>
        <b-button
                block
                variant="primary"
                size="lg"
                @click="runNakdanClicked"><span v-if="nakdanStyle.Desktop"> החל </span>ניקוד
        </b-button>
            <b-modal v-model="showTextTooLongPrompt"
                id="text-too-long-modal"
                size="sm"
                centered
                hide-header
                ok-only
                body-class="pr-0 pl-0"
                ok-title="בסדר, הבנתי"
                footer-class="text-too-long-footer"
                @ok="showTextTooLongPrompt = false">
        <p class="text-center mb-0">אפשר להעלות טקסט של עד 10000 תווים</p>
        </b-modal>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {Actions} from '@/store/stateChanges'
    import Spinner from './spinner'
    import {RunStates} from '@/store/runStates'
    import serviceMixins from '@/mixins/serviceMixins'
    import {BlankState} from '@/store/stateChanges'
    import {NakdanStyle} from '@/mobileVsDesktopConfig.js'

    export default {
        name: 'NakdanRunner',
        props: ['options'],
        components: {
            Spinner
        },
        mixins: [serviceMixins], // for gtag()
        data() {
            return {
                showTextTooLongPrompt: false,
            }
        },
        computed: {
            keymap: function () {
                return {
                    'ctrl+enter': this.runNakdanClicked
                }
            },
            nakdanStyle () {
                return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
            },
            nakdanRunning() {
                return this.$store.state.nakdanApiState === RunStates.RUNNING
            }
        },
        methods: {
            runNakdanClicked() {
                if (this.$store.state.originalDocument.text.length) {
                    if (this.$store.state.originalDocument.text.length > 10000) {
                        this.showTextTooLongPrompt = true
                    } else {
                        this.$store.commit('SET_TEXT_FOR_NAKDAN_API_CALL', this.$store.state.originalDocument.text)
                        if (this.nakdanStyle.Desktop) {
                            const nonDefaultOptions = Object.keys(BlankState.preSubmissionOptions).filter(
                                k => this.options[k] !== BlankState.preSubmissionOptions[k]
                            ).map(k => k + ': ' + this.options[k])
                            this.gtag("event", "options for nikud set", {
                                'event_category': 'user input',
                                'event_label': 'non-default options: ' + (
                                    nonDefaultOptions.length ? nonDefaultOptions.join(', ') : 'none')
                            })
                            this.$store.commit('STORE_ALL_FRONTEND_NIKUD_OPTIONS', this.options)
                        }
                        this.$store.dispatch(Actions.RUN_NAKDAN)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /* DocumentSettings-specific CSS goes here */
    .run-button {
        display: block;
        margin: 20px 14px 15px;
    }

    .spinner {
        margin: 20px auto;
    }
</style>
